import React from 'react';


export default function QuestionHTML({html}) {
    return <p className="survey-p">{html}</p>;
}
